import React from 'react'
import { Toast, ToastPrimitive, ToastViewport } from './Toast'
import { ToastProvider, useToast } from './ToastContext'
import type { ToastInstance } from './types'

interface Props {
  children?: React.ReactNode
}

const ToastList: React.FC = () => {
  const { toasts, dismiss } = useToast()

  return (
    <ToastPrimitive.Provider swipeDirection="right">
      {toasts.map(
        ({
          id,
          title,
          description,
          action,
          visible,
          variant,
          duration,
        }: ToastInstance) =>
          visible && (
            <Toast
              key={id}
              title={title}
              description={description}
              action={action}
              variant={variant}
              duration={duration}
              onOpenChange={(open) => {
                if (!open) dismiss(id)
              }}
            />
          ),
      )}
      <ToastViewport />
    </ToastPrimitive.Provider>
  )
}

const ToastContainer: React.FC<Props> = ({ children }) => {
  return (
    <ToastProvider>
      {children}
      <ToastList />
    </ToastProvider>
  )
}

export { ToastContainer }
